module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.currForm,
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": !_vm.edit,
      "placeholder": "最多20个字"
    },
    model: {
      value: (_vm.currForm.name),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "name", $$v)
      },
      expression: "currForm.name"
    }
  }), _vm._v(" "), (_vm.currForm.id) ? _c('span', [_vm._v("当前装配人数：" + _vm._s(_vm.currForm.countUsed))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图案",
      "prop": "emoji"
    }
  }, [_c('div', {
    staticClass: "bezel"
  }, [_vm._l((_vm.currForm.emojiList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "bezel-box"
    }, [_c('el-button', {
      staticClass: "bezel-close",
      attrs: {
        "icon": "circle-close",
        "disabled": !_vm.edit
      },
      on: {
        "click": function($event) {
          return _vm.tapDelete(index)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "bezel-input",
      attrs: {
        "placeholder": "请输入名称",
        "disabled": !_vm.edit
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bezel-item"
    }, [_c('UploadImg', {
      attrs: {
        "imgUrl": item.url,
        "disabled": _vm.edit
      },
      on: {
        "update:imgUrl": function($event) {
          return _vm.$set(item, "url", $event)
        },
        "update:img-url": function($event) {
          return _vm.$set(item, "url", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "bezel-tips"
    }, [_vm._v("(尺寸：155*155，jpg、png)")])], 1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.edit
    },
    on: {
      "click": _vm.tapAdd
    }
  }, [_vm._v("添加")])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.currForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "sort", $$v)
      },
      expression: "currForm.sort"
    }
  }), _vm._v(" "), _c('div', [_vm._v("数字越大越靠前")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拥有学生"
    }
  }, [_c('SelectStudent', {
    ref: "SelectStudentRef",
    attrs: {
      "disabled": _vm.edit,
      "selectVal": _vm.currForm.useType,
      "privileges": _vm.currForm.privilegeRole
    },
    on: {
      "update:selectVal": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      },
      "update:select-val": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角标图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.superscript),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "superscript", $$v)
      },
      expression: "currForm.superscript"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议40*40，最大50KB，优先SVG其次png")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-390f52a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/EmojiPack.vue
// module id = 991
// module chunks = 0